import { getToken, onMessage, getMessaging } from 'firebase/messaging';
import { firebaseApp, VAPID_KEY } from './firebase';
import router from "@/router";

let isListening = false;
let swRegistration = null;

const getMessagingInstance = () => {
  return getMessaging(firebaseApp);
};

export const setupMessageListener = () => {
  if (isListening) return;
  isListening = true;

  const messaging = getMessagingInstance();
  console.log('[FCM] messaging:', messaging);
  onMessage(messaging, (payload) => {
    console.log('[FCM] Foreground message:', payload);

    const data = payload.data || {};
    const conversationId = String(data.conversation_id || '');
    const currentRoute = router.currentRoute.value;
    console.log('[FCM] data:', data);

    const isSameConversation =
      currentRoute.path === '/chat' &&
      String(currentRoute.query.conversation || '') === conversationId;
    console.log('[FCM] isSameConversation:', isSameConversation);

    // 🔄 CASO 1 — misma conversación abierta
    if (isSameConversation) {
      console.log('[FCM] conversacion abierta:', payload);

      window.dispatchEvent(new CustomEvent('chat:refresh', {
        detail: { conversationId, payload }
      }));
      return;
    }

    // 📩 CASO 2 y 3 — otra conversación o fuera de chat

    window.dispatchEvent(new CustomEvent('chat:new-message', {
      detail: { conversationId, payload }
    }));
    console.log('[FCM] CASO 2 y 3 evento:', payload);


    // 🔔 Notificación foreground — SIN notification raíz para evitar doble
    if (Notification.permission === 'granted') {
      console.log('[FCM] envianotificacion:', payload);

      const notif = new Notification(data.title || 'Nuevo mensaje', {
        body: data.body || '',
        image: 'https://leadbox.ec/logo_leadbox.png',
        icon: 'https://leadbox.ec/logo.png',
        badge: 'https://leadbox.ec/badge.png',
        data: { conversation_id: conversationId } // ← para el click
      });

      // ✅ Auto-cerrar después de 6 segundos
      setTimeout(() => notif.close(), 4000);

      // ✅ Click en notificación foreground
      notif.onclick = () => {

        console.log('[FCM] se dió click:', payload);

        notif.close();
        window.focus();
        router.push({
          path: '/chat',
          query: { conversation: conversationId }
        }).catch(() => {
          console.log('[FCM] error en redirigir:');

          window.dispatchEvent(new CustomEvent('chat:do-refresh', {
            detail: { conversationId }
          }));
        });
      };
    }
  });
};

export const registerServiceWorker = async () => {
  if (swRegistration) return swRegistration;

  if (!('serviceWorker' in navigator)) {
    throw new Error('Service Worker no soportado');
  }

  // 🧹 Limpiar SWs viejos
  const registrations = await navigator.serviceWorker.getRegistrations();
  for (const reg of registrations) {
    const swUrl = reg.active?.scriptURL || '';
    if (!swUrl.includes('firebase-messaging-sw.js')) {
      await reg.unregister();
      console.log('[SW] Viejo eliminado:', swUrl);
    }
  }
  console.log('[FCM] registrations:', registrations);

  swRegistration = await navigator.serviceWorker.register(
    '/firebase-messaging-sw.js',
    { scope: '/', type: 'classic' }
  );

  await swRegistration.update();
  await navigator.serviceWorker.ready;

  console.log('[SW] Registrado y listo');
  return swRegistration;
};

export const registerUserToken = async (store) => {
  try {
    const permission = await Notification.requestPermission();
    if (permission !== 'granted') {
      console.warn('[FCM] Permiso denegado');
      return;
    }

    const registration = await registerServiceWorker();
    const messaging = getMessagingInstance();

    const currentToken = await getToken(messaging, {
      vapidKey: VAPID_KEY,
      serviceWorkerRegistration: registration
    });

    if (!currentToken) {
      console.warn('[FCM] No se pudo obtener token');
      return;
    }

    const savedToken = localStorage.getItem('fcm_token');
    console.log('[FCM] Token anterior:', savedToken);
    console.log('[FCM] Token nuevo:', currentToken);

    await store.dispatch('tokens', [currentToken]);
    localStorage.setItem('fcm_token', currentToken);

  } catch (error) {
    console.error('[FCM] Error registrando token:', error);
  }
};
